import { useCallback, useEffect, useState } from 'react';
import { dataHooks } from '../../../utils/datahooks';
import { useCollapseItems } from '../../../utils/use-on-rule-group-toggle';
import { useUnsavedChangesHandlers } from '../../../utils/use-unsaved-changes-handlers';
export const useRadioGroupFixer = (ruleResult, selected) => {
  var _ruleResult$fixerProp, _ruleResult$fixerProp2, _ruleResult$fixerProp3;
  const {
    onApply,
    onCancel,
    onEdit,
    radioOptions,
    defaultValue,
    radioGroupLabel,
    onSelect
  } = ruleResult.fixerProps;
  const {
    description
  } = ruleResult;
  const {
    collapseRule
  } = useCollapseItems();
  const [selectedRadioOption, setSelectedRadioOption] = useState(defaultValue);
  const [showLoader, setShowLoader] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const unsavedChangesHandlers = useUnsavedChangesHandlers();
  useEffect(() => {
    if (!selected) {
      setIsEditMode(false);
    }
    return () => {
      setIsEditMode(false);
      setShowLoader(false);
    };
  }, [selected]);
  const onEditClick = useCallback(() => {
    setIsEditMode(true);
    onEdit == null || onEdit();
  }, [setIsEditMode, onEdit]);
  const onApplyClick = useCallback(async optionToSave => {
    if (!optionToSave) {
      throw new Error('onApply was called with null value');
    }
    try {
      setShowLoader(true);
      await onApply(optionToSave);
      unsavedChangesHandlers == null || unsavedChangesHandlers.setUnsavedChanges(false, () => Promise.resolve());
    } catch (e) {
      console.error(e);
    }
    setShowLoader(false);
  }, [onApply, unsavedChangesHandlers]);
  const onChange = useCallback(selectedOption => {
    const newOption = radioOptions.find(option => option.value === selectedOption);
    setSelectedRadioOption(newOption);
    onSelect == null || onSelect(selectedOption ?? '');
    if (newOption === defaultValue) {
      unsavedChangesHandlers == null || unsavedChangesHandlers.setUnsavedChanges(false, () => Promise.resolve());
    } else {
      unsavedChangesHandlers == null || unsavedChangesHandlers.setUnsavedChanges(true, () => onApplyClick(newOption));
    }
  }, [defaultValue, onApplyClick, onSelect, radioOptions, unsavedChangesHandlers]);
  const onCancelClick = useCallback(() => {
    collapseRule();
    setSelectedRadioOption(defaultValue);
    onCancel == null || onCancel();
    unsavedChangesHandlers == null || unsavedChangesHandlers.setUnsavedChanges(false, () => Promise.resolve());
  }, [collapseRule, defaultValue, onCancel, unsavedChangesHandlers]);
  useEffect(() => {
    return () => {
      setIsEditMode(false);
    };
  }, []);
  return {
    description,
    isEditMode,
    onChange,
    onEditClick,
    radioGroupLabel,
    radioOptions,
    ruleFooterProps: {
      dataHook: dataHooks.footerRadioGroupFixer(ruleResult.dataHook),
      dismissButtonProps: {
        label: (_ruleResult$fixerProp = ruleResult.fixerProps.footerLabels) == null ? void 0 : _ruleResult$fixerProp.dismiss,
        onClick: onCancelClick,
        type: ((_ruleResult$fixerProp2 = ruleResult.fixerProps.footerLabels) == null || (_ruleResult$fixerProp2 = _ruleResult$fixerProp2.buttonTypes) == null ? void 0 : _ruleResult$fixerProp2.dismiss) ?? 'textButton'
      },
      submitButtonProps: {
        disabled: (selectedRadioOption == null ? void 0 : selectedRadioOption.value) === (defaultValue == null ? void 0 : defaultValue.value),
        label: (_ruleResult$fixerProp3 = ruleResult.fixerProps.footerLabels) == null ? void 0 : _ruleResult$fixerProp3.submit,
        onClick: () => onApplyClick(selectedRadioOption),
        showLoader
      }
    },
    selectedRadioOption
  };
};
//# sourceMappingURL=use-radio-group-fixer.js.map